import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { usersListingApi } from '@apis/seller-center/users.js';
import { Toast } from '@common-web/index.js';
import { getErrorString } from '@utils/utils.js';
import { getCurrentUserApi } from '../../../apis/seller-center/profile-settings';

const initialState = {
  users: [],
  pagination: null,
  success: false,
  loading: false,
  aggregations: [],
  cancelledDispositions: [],
};

export const fetchUsersListing = createAsyncThunk('users/listing', async (params = '', { getState }) => {
  try {
    const state = getState();
    const currentUser = state?.userData?.userInfo;
    let storeId = currentUser?.storeId;
    if (!storeId) {
      const seller = await getCurrentUserApi();
      storeId = seller?.store?.id;
    }
    const response = await usersListingApi(params, storeId);
    return response;
  } catch (err) {
    Toast.error(getErrorString(err));
    throw err;
  }
});

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      if (action?.payload?.id) {
        const usersList = [...state?.users];
        state.users = [...usersList, action?.payload];
      }
    },
    updateUsers: (state, action) => {
      if (action?.payload?.id) {
        const usersList = [...state?.users];
        const index = usersList?.findIndex((item) => item?.id === action?.payload?.id);
        if (index > -1) {
          usersList[index] = { ...usersList[index], ...action?.payload };
        }
        state.users = [...usersList];
      }
    },
    removeUser: (state, action) => {
      if (action?.payload?.id) {
        const usersList = [...state?.users];
        state.users = usersList?.filter((item) => item?.id !== action?.payload?.id);
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUsersListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsersListing.fulfilled, (state, action) => {
        state.users = action?.payload?.users;
        state.success = action?.payload?.success;
        state.pagination = action?.payload?.pagination;
        state.loading = false;
      })
      .addCase(fetchUsersListing.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setUsers, removeUser, updateUsers } = usersSlice.actions;
export default usersSlice.reducer;
